import { ModalData } from "@/app/(workspace)/_hooks/useModal";
import { Button } from "@/components/ui/Button";

export function MessageModal({
    data,
    onClose,
}: {
    data: ModalData;
    onClose: () => void;
}) {
    const { message, confirmText, cancelText, onConfirm } = data;

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm(null);
        }
        onClose();
    };

    const handleCancel = () => {
        onClose();
    };

    // cancelText가 있으면 Confirm/Cancel 모달, 없으면 기존 방식
    const showCancelButton = !!cancelText;

    return (
        <div className="p-6">
            <div className="mt-2">
                <div className="text-sm text-zinc-500 dark:text-zinc-400">
                    {message}
                </div>
            </div>

            <div className="mt-6 flex justify-end gap-3">
                {showCancelButton && (
                    <Button variant="secondary" onClick={handleCancel}>
                        {cancelText}
                    </Button>
                )}
                <Button variant="filled" onClick={handleConfirm}>
                    {confirmText || "Close"}
                </Button>
            </div>
        </div>
    );
}
